import { Button, ButtonBase } from "@mui/material";
import React from "react";
import logo from '../assets/TLF-logo.png';

interface EndGameProps {
    onRestartGame: () => void;
}

export const EndPage = (props: EndGameProps) => {
    const { onRestartGame } = props;
    const link = "https://www.chestnet.org/Guidelines-and-Topic-Collections/Bridging-Specialties/Timely-Diagnosis-for-ILD-Patients";

    const openPage = (link: string) => {
        window.open(link, '_blank');
    }

    return (
        <div className="end-page">
            <h1>An earlier diagnosis can give a patient more time.</h1>
            <p>Stay involved, click here for tools to help you in practice to improve timely diagnosis in ILD!</p>
                <div>
                    <ButtonBase onClick={() => openPage(link)}>
                        <div className="learn-more">
                            <p>Learn More →</p>
                        </div>
                    </ButtonBase>
                </div>
            <div className="partnership-block">
                <p><b>In partnership with <span><img src={logo} alt="Three Lakes Foundation"/></span></b></p>
            </div>
            <div className="special-thanks-block">
                <p>Special Thanks To:</p>
                <p>Corey D. Kershaw, MD, FCCP - SME</p>
                <p>Mary Beth Scholand, MD - SME</p>
                <p>Jessica Glennie APRN, MSN - SME</p>
                <p>William Lago MD - SME</p>
                <p>Banana Chan - Writer</p>
            </div>
            <div className="divider"></div>
            <p>Time is Lung Capacity</p>
            <p>Time is breath</p>
            <p>Time is life</p>
            <Button color="info" onClick={onRestartGame}>Restart Game</Button>
        </div>
    );
}